import { useState } from 'react';

const useNotification = () => {
  const [notification, setNotification] = useState(null); // Support both message and type

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type }); // Store both message and type
    setTimeout(() => setNotification(null), 3000); // Clear notification after 3 seconds
  };

  return { notification, showNotification };
};

export default useNotification;
